import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PageLayout from './PageLayout';
import PageHeader from './ui/PageHeader';
import PageBody from './ui/PageBody';
import PageMain from './ui/PageMain';
import AccountCard from './AccountCard';
import useAuth from '../auth/useAuth';

function AdminHome() {
    const { t } = useTranslation();
    const { user } = useAuth();

    return (
        <PageLayout
            extraSidebarItems={[
                {
                    to: '/admin',
                    label: t('adminHome.sidebarTitle'),
                    icon: 'fa-solid fa-user-shield',
                },
            ]}
        >
            <PageMain>
                <PageHeader
                    eyebrow={t('adminPanel.eyebrow')}
                    title={t('adminHome.title')}
                    titleId="admin-home-title"
                    description={t('adminHome.description')}
                />

                <PageBody
                    className="account-page"
                    aria-labelledby="admin-home-title"
                >
                    <div className="account-settings-column admin-settings-column">
                        <Link
                            to="/admin/rechte"
                            style={{
                                display: 'block',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                            aria-label={t('adminHome.rightsAriaLabel')}
                        >
                            <AccountCard
                                titleId="admin-home-rights-title"
                                title={t('adminHome.rightsTitle')}
                                description={t('adminHome.rightsDescription')}
                                icon="fa-solid fa-key"
                                hideToggle
                            />
                        </Link>

                        <Link
                            to="/admin/werkzeuge"
                            style={{
                                display: 'block',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                            aria-label={t('adminHome.toolsAriaLabel')}
                        >
                            <AccountCard
                                titleId="admin-home-tools-title"
                                title={t('adminHome.toolsTitle')}
                                description={t('adminHome.toolsDescription')}
                                icon="fa-solid fa-screwdriver-wrench"
                                hideToggle
                            />
                        </Link>

                        {user?.rightsAnywhere?.includes('plugins.manage') && (
                            <Link
                                to="/admin/plugins"
                                style={{
                                    display: 'block',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                }}
                                aria-label={t('adminHome.pluginsAriaLabel')}
                            >
                                <AccountCard
                                    titleId="admin-home-plugins-title"
                                    title={t('adminHome.pluginsTitle')}
                                    description={t('adminHome.pluginsDescription')}
                                    icon="fa-solid fa-puzzle-piece"
                                    hideToggle
                                />
                            </Link>
                        )}
                    </div>
                </PageBody>
            </PageMain>
        </PageLayout>
    );
}

export default AdminHome;